export default "__VITE_ASSET__ff02dd9d__"